import * as React from 'react';

import ErrorBoundaryWithTagging from 'bundles/common/components/ErrorBoundaryWithTagging';

import _t from 'i18n!nls/unified-common';

type Props = {
  style: 'narrow' | 'short' | 'long';
  type: 'conjunction' | 'disjunction' | 'unit';
  list?: Array<string>;
};

// Intl.ListFormat is available on macOS Big Sur (initial released on November 12, 2020) and above. https://caniuse.com/?search=listformat
// Wrapping it in ErrorBoundary to catch any errors that may occur in older versions of macOS before a polyfill is added.
// TODO: add a polyfill for Intl.ListFormat for older versions of macOS.
// https://coursera.atlassian.net/browse/MERCH-738
export const FormattedList = (props: Props) => {
  const { list, style, type } = props;

  if (!list) {
    return null;
  }

  return (
    <ErrorBoundaryWithTagging errorComponent={<>{list.join(_t(', '))}</>} componentName="FormattedList">
      {new Intl.ListFormat(_t.getLocale(), {
        style,
        type,
      }).format(list)}
    </ErrorBoundaryWithTagging>
  );
};

export default FormattedList;
